/************
 Swipers
 ************/

// thumbnails mobile
let productV26ThumbnailImages = new Swiper("#productV26ThumbnailsSwiper", {
    slidesPerView: "auto",
    spaceBetween: 5,
    breakpoints: {
        800: {
            slidesPerView: 6,
        }
    },
    loop: true,
    navigation: {
        nextEl: '#productV26ThumbnailsNext',
        prevEl: '#productV26ThumbnailsPrev',
    },
});

// main swiper
let productV26Images = new Swiper("#productV26Swiper", {
    navigation: {
        nextEl: '#productV26Swiper .productV26SwiperNext',
        prevEl: '#productV26Swiper .productV26SwiperPrev',
    },
    loop: true,
    thumbs: {
        swiper: productV26ThumbnailImages
    }
});

// gallery desktop
document.querySelectorAll(".productV26GalleryItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productV26Images.slideTo(index);
    });
});

/********************
 Video Popup
 *******************/

// open video
document.querySelectorAll('.productV26Video')?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const popup = document.querySelector(".videoPopup");
        popup.showModal();
        popup.querySelector("video").play();
    })
})


/*****************
 Reviews
 ****************/

document.querySelector("#productV26Review")?.addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
})


/**************
 Function To Update Pricing
 ***************/

// update active variant
function updateProductV18(skipImage) {
    // There are 3 senarios to determine the active variant
    // 1. Has only a default variant
    // 2. the color/background swatch
    // 3. the basic dropdown

    // check for an active color swatch
    if (product.variants.length === 1) {
        activeVariant = product.variants[0];
    } else if (document.querySelector(".productV26FormGroup.active")) {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector(".productV26FormGroupFlexColor:checked").value)
        })[0];
    } else {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector("#productV26FormVariants").value)
        })[0];
    }

    // find variant image
    if (activeVariant.featured_image && !skipImage) {
        const variantImage = document.querySelector(`.productV26SwiperSlide[id="${activeVariant.featured_image.id}"]`);
        if (variantImage) {
            productV26Images.slideTo(getElIndex(variantImage));
        }
    }

    // in the variant available?
    let isAvailable = activeVariant.available;

    // default quantity and discount
    let quantity = 1;
    let discount = 0;

    // compute price and compare at price
    let total = activeVariant.price * quantity - discount;
    let compareAtTotal = activeVariant.compare_at_price * quantity;


    // update display
    if (total < compareAtTotal) {
        document.querySelector("#productV26PriceCompare").textContent = price(compareAtTotal, true);
        document.querySelector("#productV26PriceActual").textContent = `${price(total, true)}`;

        if (!document.querySelector('#productV26PriceSavings').classList.contains('noUpdate')) {
            document.querySelector("#productV26PriceSavings").textContent = `SAVE 40 %`;
        }
        document.querySelector("#productV26PriceSavings").classList.add('active');

    } else {
        document.querySelector("#productV26PriceCompare").textContent = "";
        document.querySelector("#productV26PriceActual").textContent = price(total, true);
        document.querySelector("#productV26PriceSavings").classList.remove('active');
    }


    // check if the variant is in stock
    if (isAvailable) {
        document.querySelector("#productV26ATC").classList.remove("oos");
        document.querySelector("#productV26ATC").textContent = document.querySelector("#productV26ATC").dataset.text;
    } else {
        document.querySelector("#productV26ATC").classList.add("oos");
        document.querySelector("#productV26ATC").textContent = "Sold Out — Notify Me When Available";
    }

}

/*******************
 Product Form (Default and Group)
 ********************/

// color swatch support on change
document.querySelectorAll(".productV26FormGroupFlexColor").forEach(function (element) {
    element.addEventListener("change", function () {
        // update label
        this.parentElement.parentElement.parentElement.querySelector(".productV26FormGroupHeaderLabel").innerHTML = this.getAttribute("aria-label");

        // update price
        updateProductV18();
    });
});

/****************
 *  Quantity
 *************/

let quantity = 1;


/**************
 Product ATC
 ***************/

// add to cart button
/*Code for adding Shipping Insurance*/
document.querySelector("#productV26ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");


    // create form data
    let formData = {
        items: []
    };

    // normal product
    formData.items.push({
        quantity: quantity,
        id: activeVariant.id,
        properties: {
            "_hide_free_gift_banner": true
        }
    });


    // check if we should go directly to checkout
    if (this.classList.contains('checkout')) {

        await clearCart();

        await addProduct(formData)

        window.location.href = '/checkout';

        // klaviyo tracking
        try {
            _learnq.push(['track', 'Added to Cart', item]);
        } catch (error) {
            console.error("Klaviyo tracking not found");
        }

        // remove loading animation
        this.classList.remove("loading");

        return;
    }


    // add productV26
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }


    // open cart
    await openCart();


    // remove loading animation
    this.classList.remove("loading");

});

//space
// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV26ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV26ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

/**************
 Sticky ATC
 ***************/

// ignore if noSticky class is present
if (!document.querySelector("#productV26ATC").classList.contains("noSticky")) {
    const stickyAtcObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                document.querySelector("#productV26ATC").classList.remove("sticky");
            } else {
                document.querySelector("#productV26ATC").classList.add("sticky");
            }
        });
    }, {
        rootMargin: "-100px 0px 0px 0px"
    })
    stickyAtcObserver.observe(document.querySelector("#productV26Content"));

}


// event listeners for dropdown items
document.querySelectorAll(`.productV26DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

/**************
 Shipping Time
 ***************/

// Consistent random number generation using the hash as a seed
function generateSeededRandom(key, min, max) {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash << 5) - hash + key.charCodeAt(i);
        hash |= 0;
    }

    const x = Math.sin(hash) * 10000;
    const seed = x - Math.floor(x);

    return Math.floor(seed * (max - min + 1) + min);
}

let ordersRemaining = localStorage.getItem('ordersRemaining');

// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    if (document.querySelector('#productV26ShippingRemainingTxt')) {
        document.querySelector('#productV26ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
    }
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);

    if (document.querySelector('#productV26ShippingRemainingTxt')) {
        document.querySelector('#productV26ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
    }
}

// show shipping tomorrow
let date = new Date();
date.setDate(date.getDate() + 1);
date = date.toLocaleDateString('en-US', {month: 'short', day: 'numeric'});
document.querySelector('#productV26ShippingDateTxt').innerHTML = `Ships <strong>Tomorrow, ${date}</strong>`;


// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    document.querySelector('#productV26ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);
    document.querySelector('#productV26ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
}